import React from 'react'
import PbIndicadorFormPageContainer from './PbIndicadorFormPageContainer'

export class PbIndicadorFormPage extends React.Component {
  render() {
    return <PbIndicadorFormPageContainer {...this.props} />
  }
}
